var render = function render(){var _vm=this,_c=_vm._self._c;return (this.currentCoins >= 0)?_c('div',{staticClass:"dynamic-coin-counter flexbox column justify-content-center align-center position-absolute"},[_c('p',{staticClass:"student__coins plus transparent position-absolute",attrs:{"id":"dcc"}}),_c('p',{staticClass:"student__coins coin"},[_vm._v(" "+_vm._s(_vm.currentCoins)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }